import store from '../configureStore';
import { apiGet } from './apiUtil';

const searchItems = (searchString: string) => {
  const {
    project: { header },
    workspace: { currentUserGroup },
  } = store.getState();
  return apiGet(`/search?gid=${currentUserGroup}&search=${searchString}`, {
    headers: header ? { Authorization: header } : undefined,
  });
};

export default searchItems;
